export const SessionStorageKeys = {
  APPLICATION_LOADED: 'APPLICATION_LOADED',
};
